// Glow Trail product section (Shopify port of glow-trail-store/app.js).
// Reads #GlowData (media, bundles from variants, gift) written by sections/glow-product.liquid.
(function () {
  const dataEl = document.getElementById('GlowData');
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const $ = id => document.getElementById(id);

  const money = cents => {
    const n = (cents / 100).toFixed(2);
    return (D.moneyFormat || '£{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, n).replace(/<[^>]*>/g, '');
  };

  /* ---------- gallery: one-row thumbs, arrows, swipe, video autoplays muted ---------- */
  const thumbs = $('thumbs'), mainImg = $('mainImg'), mainVid = $('mainVid');
  let gIdx = 0;
  // Phones get the 900px images; bigger screens the 1400px ones.
  const small = window.innerWidth * (window.devicePixelRatio || 1) <= 1300;
  const pick = m => (small && m.srcM) ? m.srcM : m.src;
  const poster = m => (small && m.posterM) ? m.posterM : m.poster;
  // Swap the main image only once the new one is decoded, and ignore stale loads from quick clicks (fixes the flash/glitch).
  let swapToken = 0;
  function setMainImg(src, alt) {
    const t = ++swapToken;
    const im = new Image(); im.decoding = 'async'; im.src = src;
    const done = () => {
      if (t !== swapToken) return;
      mainVid.pause(); mainVid.hidden = true; mainImg.hidden = false;
      mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.alt = alt || '';
    };
    (im.decode ? im.decode() : Promise.resolve()).then(done, done);
  }
  function showSlide(i) {
    if (!D.media.length) return;
    gIdx = (i + D.media.length) % D.media.length;
    const m = D.media[gIdx];
    if (m.type === 'video') {
      ++swapToken;
      mainImg.hidden = true; mainVid.hidden = false;
      mainVid.muted = true; mainVid.autoplay = true;
      if (mainVid.dataset.src !== m.src) { mainVid.dataset.src = m.src; mainVid.poster = poster(m); mainVid.src = m.src; }
      else { mainVid.currentTime = 0; mainVid.play().catch(() => {}); }
    } else {
      setMainImg(pick(m), m.alt);
    }
    const btns = thumbs.querySelectorAll('button');
    btns.forEach((x, n) => x.classList.toggle('active', n === gIdx));
    const b = btns[gIdx];
    if (b) thumbs.scrollTo({ left: b.offsetLeft - (thumbs.clientWidth - b.clientWidth) / 2 });
  }
  D.media.forEach((m, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.innerHTML = `<img src="${m.thumb}" alt="">` + (m.type === 'video'
      ? '<span class="play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>' : '');
    b.setAttribute('aria-label', m.type === 'video' ? 'Play video' : `Image ${i + 1}`);
    b.onclick = () => { stopAuto(); showSlide(i); };
    thumbs.appendChild(b);
  });
  $('gPrev').onclick = () => { stopAuto(); showSlide(gIdx - 1); };
  $('gNext').onclick = () => { stopAuto(); showSlide(gIdx + 1); };
  let touchX = null;
  const stage = mainImg.parentElement;
  stage.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', e => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) { stopAuto(); showSlide(gIdx + (dx < 0 ? 1 : -1)); }
    touchX = null;
  });
  showSlide(0);
  // Show a one-off image (e.g. the chosen single-stone colour) without touching the thumbs list.
  let customShown = false;
  function showImage(m) {
    if (!m || !m.src) return;
    stopAuto(); customShown = true;
    setMainImg(pick(m), m.alt);
    thumbs.querySelectorAll('button').forEach(x => x.classList.remove('active'));
  }
  function restoreGallery() { if (customShown) { customShown = false; showSlide(gIdx); } }
  // Auto-advance every 4s until the shopper picks an image themselves (thumb, arrow or swipe).
  // Pauses on hover, while the gallery is off screen or the tab is hidden; a video slide plays through first.
  let autoOn = D.media.length > 1, hover = false, seen = true;
  function stopAuto() { autoOn = false; }
  function canTick() { return autoOn && !hover && seen && !document.hidden; }
  setInterval(() => {
    if (!canTick()) return;
    const m = D.media[gIdx];
    if (m && m.type === 'video' && !mainVid.ended && mainVid.currentTime < 6) return;
    showSlide(gIdx + 1);
  }, 4000);
  stage.addEventListener('mouseenter', () => { hover = true; });
  stage.addEventListener('mouseleave', () => { hover = false; });
  if ('IntersectionObserver' in window) new IntersectionObserver(es => { seen = es[0].isIntersecting; }, { threshold: 0.4 }).observe(stage);
  // Preload every gallery image once the page is idle, so arrows and swipes switch instantly.
  const preload = () => D.media.forEach(m => { const im = new Image(); im.decoding = 'async'; im.src = m.type === 'video' ? poster(m) : pick(m); });
  if (document.readyState === 'complete') setTimeout(preload, 300); else window.addEventListener('load', () => setTimeout(preload, 300));

  /* ---------- bundles ---------- */
  const B = D.bundles;
  if (!B.length) {
    // No matching variants yet: show the setup note, hide the buy UI instead of rendering it empty.
    $('glowSetup').hidden = false;
    ['addToCart', 'sticky'].forEach(id => { const el = $(id); if (el) el.style.display = 'none'; });
    document.querySelectorAll('.glow .gifts, .glow .delivery').forEach(el => { el.style.display = 'none'; });
    return;
  }
  /* ---------- free delivery: one threshold (theme setting, pence) for every card ---------- */
  const FREE_MIN = Number(D.freeMin) || 0, SHIP = Number(D.shipPrice) || 0;
  const qty = () => (current === SINGLE ? count() : 1);
  // Single-stone volume price, matching the automatic discounts in Shopify admin (3+ / 4+ / 6+ on the Single variant, counted across all lines).
  const TIERS = [[6, 3000], [4, 3250], [3, 3333]]; // 29 Oct new prices: 3 £99.99, 4 £129.99, 6 £179.99 per stone
  const singleUnit = q => { const t = TIERS.find(([n]) => q >= n); return t ? Math.min(t[1], current && SINGLE ? SINGLE.price : t[1]) : (SINGLE ? SINGLE.price : 0); };
  const nextTier = q => TIERS.slice().reverse().find(([n]) => n > q);
  const total = () => (current === SINGLE ? singleUnit(count()) * count() : current.price);
  // Q4 gift ladder (10 Oct): counted in stones. A set counts as its pieces, single stones one each.
  // 3+ = free delivery, 4+ = free Glow Sensory Spinner, 6+ = 2 free gifts (spinner + mat tile). Same steps as the cart drawer.
  const LADDER = [
    { n: 3, what: 'free delivery' },
    { n: 4, what: 'a free Glow Sensory Spinner 🎁' },
    { n: 6, what: '2 free gifts 🎁🎁' },
  ];
  const FREE_STONES = LADDER[0].n;
  const stonesOf = b => (b === SINGLE ? count() : (b && b.pieces) || 0);
  const nextStep = n => LADDER.find(s => s.n > n);
  const freeFor = b => stonesOf(b) >= FREE_STONES;
  B.forEach(b => { b.freeShipping = b.pieces >= FREE_STONES; });

  /* ---------- single stone: 4th card = this product's 1-piece variant; shape + colour go on as line item properties ---------- */
  const S = D.single && D.single.shapes && D.single.shapes.length && D.single.colours && D.single.colours.length ? D.single : null;
  const spEl = $('singlePick');
  const MAX_Q = 12;
  // sShape/sColour = the shape tab and the last colour tapped (drives the gallery photo);
  // tray = the stones picked so far, one row per shape + colour: { sh, c, n }
  let SINGLE = null, sShape = 0, sColour = 0, tray = [{ sh: 0, c: 0, n: 1 }];
  if (S && spEl) {
    // compare-at is ignored for the single on purpose (no "was" price on one stone)
    SINGLE = { single: true, pieces: 1, variantId: S.variantId, available: S.available, price: S.price, was: S.price, perStone: S.price, perSave: 0,
      title: S.title, contents: S.contents, box: '', pill: '', freeGift: false };
  }
  const count = () => tray.reduce((s, r) => s + r.n, 0);
  const imgUrl = (w, sh = sShape, c = sColour) => `${S.imgBase}${S.shapes[sh].slug}-${S.colours[c].slug}.jpg?width=${w}`;
  const singleLabel = (sh = sShape, c = sColour) => `${S.colours[c].name} ${S.shapes[sh].slug}`;
  const rowLabel = r => `${r.n} ${S.colours[r.c].name} ${S.shapes[r.sh].slug}${r.n > 1 ? 's' : ''}`;
  // "2 Purple domes, 1 Orange tile" (+N more after two combos)
  const trayText = (max = 2) => tray.slice(0, max).map(rowLabel).join(', ') + (tray.length > max ? ` +${tray.length - max} more` : '');
  function addStone(sh, c, n = 1) {
    n = Math.min(n, MAX_Q - count()); if (n <= 0) return;
    const r = tray.find(x => x.sh === sh && x.c === c);
    if (r) r.n += n; else tray.push({ sh, c, n });
  }
  // stones needed for free delivery, and how many more to the next ladder step from the current count
  const needStones = () => FREE_STONES;
  const moreStones = () => { const s = nextStep(count()); return s ? s.n - count() : 0; };
  const ord = n => n + (n % 10 === 1 && n !== 11 ? 'st' : n % 10 === 2 && n !== 12 ? 'nd' : n % 10 === 3 && n !== 13 ? 'rd' : 'th');
  // one short line, used in the picker and the sticky bar: "Add 1 more for a free Glow Sensory Spinner 🎁"
  const nudgeText = () => {
    const s = nextStep(count()), m = moreStones();
    return s ? `Add ${m} more for ${s.what}` : '';
  };
  function syncSingle() { if (SINGLE) SINGLE.img = imgUrl(200); }

  // Shopify's /discount/<code>?redirect= drops the ?variant, so "Tap to apply" parks the shopper's choice (set, or the single
  // stones tray) in sessionStorage for 10 minutes and it's restored here when they land back without a ?variant.
  let backSel = null;
  try {
    const raw = sessionStorage.getItem('glowCouponBack'); sessionStorage.removeItem('glowCouponBack');
    const b = raw && JSON.parse(raw);
    if (b && Date.now() - b.t < 600000) backSel = b;
  } catch (e) {}
  const urlVariant = Number(new URLSearchParams(location.search).get('variant')) || (backSel ? Number(backSel.v) : 0);
  let current = B.find(b => b.variantId === urlVariant) || B.find(b => b.selected) || B[B.length - 1];
  if (SINGLE) {
    if (S.variantId === urlVariant) current = SINGLE;
    if (backSel && backSel.v === S.variantId && Array.isArray(backSel.tray) && backSel.tray.length) {
      const ok = backSel.tray.filter(r => r && S.shapes[r.sh] && S.colours[r.c] && r.n > 0).map(r => ({ sh: r.sh, c: r.c, n: Math.min(r.n, MAX_Q) }));
      if (ok.length) { tray = ok; sShape = ok[ok.length - 1].sh; sColour = ok[ok.length - 1].c; }
    }
    syncSingle();
  }
  const cards = () => SINGLE ? B.concat(SINGLE) : B;
  const bundlesEl = $('bundles');

  // Gift ladder above the cards (server-rendered <ol id="glowLadder">): tick every step the selection reaches,
  // mark the highest one, and outline the next one to aim for.
  const ladderEl = $('glowLadder');
  function renderLadder() {
    if (!ladderEl) return;
    const n = stonesOf(current), nx = nextStep(n);
    const reached = LADDER.filter(s => s.n <= n).pop();
    ladderEl.querySelectorAll('li').forEach(li => {
      const k = Number(li.dataset.n);
      li.classList.toggle('on', k <= n);
      li.classList.toggle('cur', !!reached && k === reached.n);
      li.classList.toggle('next', !!nx && k === nx.n);
    });
  }
  // Coupon chip: "Tap to apply" comes back to this product with the chosen set / single selected.
  const couponEl = $('glowCoupon');
  function syncCoupon() {
    if (!couponEl || !D.coupon) return;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const back = (D.productUrl || location.pathname) + '?variant=' + current.variantId;
    couponEl.href = `${root}discount/${encodeURIComponent(D.coupon)}?redirect=${encodeURIComponent(back)}`;
  }
  const couponApplied = () => {
    couponEl.classList.add('is-applied'); couponEl.classList.remove('is-bad');
    couponEl.innerHTML = `<span class="g-coupon__txt"><span aria-hidden="true">✓</span> <b>${D.coupon}</b> applied · 10% off at checkout</span>`;
  };
  const couponBad = () => {
    couponEl.classList.add('is-bad');
    if (!couponEl.querySelector('.g-coupon__note')) couponEl.insertAdjacentHTML('beforeend', '<small class="g-coupon__note" role="status">This code can’t be used with this cart</small>');
  };
  // 'applied' = on the cart and applicable (or on an empty cart, where it applies once something's added); 'blocked' = on the cart but not applicable
  const couponState = c => {
    const lc = D.coupon.toLowerCase();
    const dc = (c.discount_codes || []).find(d => String(d.code || '').toLowerCase() === lc);
    const app = (c.cart_level_discount_applications || []).some(d => String(d.title || '').toLowerCase() === lc);
    if (app || (dc && (dc.applicable || !c.item_count))) return 'applied';
    return dc ? 'blocked' : '';
  };
  // Tap to apply: add the code to the cart in place (Ajax cart, no page change). If that fails, follow the /discount/ link.
  if (couponEl) couponEl.addEventListener('click', async e => {
    if (couponEl.classList.contains('is-applied')) { e.preventDefault(); return; }
    try { sessionStorage.setItem('glowCouponBack', JSON.stringify({ v: current.variantId, t: Date.now(), tray: current === SINGLE ? tray : null })); } catch (err) {}
    if (!window.fetch) return;
    e.preventDefault();
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const r = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: D.coupon }) });
      if (!r.ok) throw new Error('update failed');
      const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      try { sessionStorage.removeItem('glowCouponBack'); } catch (err) {}
      if (couponState(c) === 'applied') couponApplied(); else couponBad();
      if (window.GlowCart && window.GlowCart.refresh && !document.getElementById('GlowCart').hidden) window.GlowCart.refresh();
    } catch (err) { window.location.href = couponEl.href; }
  });
  // If the code is already on the cart (after "Tap to apply"), say so instead of asking again.
  if (couponEl && D.coupon) {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json()).then(c => {
        if (couponState(c) === 'applied') couponApplied();
      }).catch(() => {});
  }

  // Simple cards (v47): thumbnail · name + one short line · price with the compare-at struck through.
  // The one line is the price per stone, or what's free on the gift sets (with small gift thumbnails).
  // 14 Oct (Glow Pad): D.ladder is false on products without the stone gift ladder, D.unitName is the word in "£X per stone",
  // and a card's own line (b.line) replaces the default one. All three default to the stones behaviour.
  const giftLine = b => {
    if (b.single || D.ladder === false || b.pieces < LADDER[1].n) return '';
    const two = b.pieces >= LADDER[2].n;
    const imgs = `<img src="${D.spinnerImg || ''}" alt="" width="22" height="22">` + (two ? `<img src="${D.giftImg || ''}" alt="" width="22" height="22">` : '');
    return `<span class="b-gl"><span class="b-gl__im">${imgs}</span><span>${two ? 'Free spinner + mat tile' : 'Free sensory spinner'}</span></span>`;
  };
  function renderBundles() {
    bundlesEl.innerHTML = '';
    cards().forEach(b => {
      const save = b.was - b.price;
      const on = b === current;
      const line = b.single
        ? `<span class="b-nudge">Pick shape &amp; colour · 3+ from ${money(TIERS[TIERS.length - 1][1])} each</span>`
        : (b.line || giftLine(b) || (b.perStone ? `${money(b.perStone)} per ${D.unitName || 'stone'}` : ''));
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'bundle b2' + (b.single ? ' is-single' : '') + (on ? ' active' : '') + (b.available ? '' : ' sold-out');
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.single) el.setAttribute('aria-expanded', on ? 'true' : 'false');
      el.innerHTML = `
        ${b.pill ? `<span class="flag ${b.pillClass}">${b.pill}</span>` : ''}
        <div class="b2-row">
          ${b.img ? `<img class="b2-img" src="${b.img}" alt="" width="52" height="52">` : ''}
          <div class="b2-main">
            <div class="b2-name">${b.title || `Buy ${b.pieces}`}</div>
            ${line || !b.available ? `<div class="b2-line">${line}${b.available ? '' : ' · Sold out'}</div>` : ''}
          </div>
          <div class="b2-price">${money(b.price)}${save > 0 ? `<s class="was">${money(b.was)}</s>` : ''}</div>
        </div>`;
      el.dataset.variant = b.variantId;
      el.onclick = () => {
        const was = current; current = b; update();
        if (b.single) { showSingleImage(); if (was !== b) spEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        else restoreGallery();
      };
      bundlesEl.appendChild(el);
    });
  }

  /* ---------- single stone builder: shape tabs, colour swatches add stones to the "Your stones" tray (markup is server-rendered) ---------- */
  function showSingleImage() { if (SINGLE) showImage({ src: imgUrl(1400), srcM: imgUrl(900), alt: `${S.title}: ${singleLabel()}` }); }
  const swFor = (sh, c) => { const b = spEl.querySelector(`.sp-sw[data-colour="${c}"]`); return b ? b.getAttribute('data-sw-' + S.shapes[sh].slug) || '' : ''; };
  function renderPicker() {
    if (!SINGLE) return;
    spEl.hidden = current !== SINGLE;
    if (spEl.hidden) return;
    spEl.querySelectorAll('.sp-shape').forEach(b => {
      const on = Number(b.dataset.shape) === sShape;
      b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    // swatches are the round gel-colour PNGs for the current shape (data-sw-dome / data-sw-tile)
    const shapeSlug = S.shapes[sShape].slug, n = count(), full = n >= MAX_Q;
    spEl.querySelectorAll('.sp-sw').forEach(b => {
      const c = Number(b.dataset.colour);
      b.classList.toggle('on', c === sColour);
      b.setAttribute('aria-label', `Add a ${singleLabel(sShape, c)}`);
      const im = b.querySelector('img'), want = b.getAttribute('data-sw-' + shapeSlug);
      if (im && want && im.getAttribute('src') !== want) im.src = want;
    });
    $('spColour').textContent = S.colours[sColour].name;
    // tray: one row per shape + colour
    $('spTray').innerHTML = tray.length ? tray.map((r, i) => `
      <div class="sp-row">
        <button type="button" class="sp-rn" data-show="${i}"><img src="${swFor(r.sh, r.c)}" alt="" width="22" height="22"><span>${singleLabel(r.sh, r.c)}</span></button>
        <div class="sp-rq" role="group" aria-label="${singleLabel(r.sh, r.c)}">
          <button type="button" data-row="${i}" data-d="-1" aria-label="One fewer ${singleLabel(r.sh, r.c)}">−</button>
          <span>${r.n}</span>
          <button type="button" data-row="${i}" data-d="1" aria-label="One more ${singleLabel(r.sh, r.c)}"${full ? ' disabled' : ''}>+</button>
        </div>
      </div>`).join('') : '<p class="sp-empty">Tap a colour to add a stone</p>';
    // one status line: count · price each · delivery (+ next-tier hint at 2)
    const ship = $('spShip');
    ship.hidden = !n;
    if (!n) { ship.innerHTML = ''; return; }
    const unit = singleUnit(n), nt = nextTier(n);
    const parts = [`<b class="sp-n">${n} stone${n > 1 ? 's' : ''}</b>`];
    if (unit < SINGLE.price) parts.push(`${money(unit)} each`);
    // what they've unlocked so far, then the next step
    const got = n >= LADDER[2].n ? '✓ Free delivery + 2 free gifts' : n >= LADDER[1].n ? '✓ Free delivery + free gift' : n >= FREE_STONES ? '✓ Free delivery' : '';
    if (got) parts.push(`<b class="ok">${got}</b>`);
    if (nextStep(n) && n + moreStones() <= MAX_Q) parts.push(`<b>${nudgeText()}</b>`);
    if (nt && n >= 2 && unit >= SINGLE.price) parts.push(`<span class="sp-each">${nt[0]}+ = ${money(nt[1])} each</span>`);
    if (full) parts.push(`<span class="sp-each">${MAX_Q} max</span>`);
    ship.innerHTML = parts.join(' · ');
  }
  if (SINGLE) {
    spEl.addEventListener('click', e => {
      const shapeBtn = e.target.closest('.sp-shape'), sw = e.target.closest('.sp-sw'), step = e.target.closest('[data-d]'), show = e.target.closest('[data-show]');
      if (shapeBtn) { sShape = Number(shapeBtn.dataset.shape); }
      else if (sw) { sColour = Number(sw.dataset.colour); addStone(sShape, sColour); }
      else if (step) {
        const r = tray[Number(step.dataset.row)]; if (!r) return;
        if (Number(step.dataset.d) > 0) addStone(r.sh, r.c); else if (--r.n <= 0) tray.splice(tray.indexOf(r), 1);
        update(); return;
      }
      else if (show) { const r = tray[Number(show.dataset.show)]; if (!r) return; sShape = r.sh; sColour = r.c; }
      else return;
      syncSingle(); update(); showSingleImage();
    });
    // preload the 1400/900 colour images for the current shape once the single is opened
    let preloaded = {};
    spEl.addEventListener('pointerenter', () => {
      if (preloaded[sShape]) return; preloaded[sShape] = true;
      S.colours.forEach((c, i) => { const im = new Image(); im.src = imgUrl(small ? 900 : 1400, sShape, i); });
    });
  }
  const stickyNudge = $('stickyNudge');
  // "+ Add 1 more" in the sticky bar adds more of the last stone picked (or the current shape + colour)
  if (stickyNudge) stickyNudge.onclick = () => {
    if (current !== SINGLE) return;
    const last = tray[tray.length - 1] || { sh: sShape, c: sColour };
    addStone(last.sh, last.c, moreStones()); update();
  };

  /* ---------- gifts unlocked ---------- */
  const lock = '<span class="glock"><svg viewBox="0 0 24 24" width="26" height="26"><rect x="5" y="10" width="14" height="11" rx="2.5" fill="#1E2A4A"/><path d="M8 10V7a4 4 0 0 1 8 0v3" fill="none" stroke="#1E2A4A" stroke-width="2.4"/><circle cx="12" cy="15.5" r="1.6" fill="#fff"/></svg><b>Locked</b></span>';
  const truck = '<svg viewBox="0 0 120 80" class="truck"><rect x="4" y="14" width="72" height="44" rx="6" fill="#1E2A4A"/><path d="M76 26h22l14 16v16H76z" fill="#2B3A63"/><rect x="84" y="30" width="14" height="10" rx="2" fill="#F6F1EA"/><circle cx="26" cy="62" r="9" fill="#fff" stroke="#1E2A4A" stroke-width="5"/><circle cx="94" cy="62" r="9" fill="#fff" stroke="#1E2A4A" stroke-width="5"/><text x="40" y="35" text-anchor="middle" font-family="Manrope" font-weight="800" font-size="15" fill="#F2B38A" font-style="italic">FREE</text><text x="40" y="49" text-anchor="middle" font-family="Manrope" font-weight="700" font-size="8.5" fill="#fff" font-style="italic">SHIPPING</text></svg>';
  const minPieces = key => { const b = B.find(x => x[key]); return b ? b.pieces : null; };
  function renderGifts() {
    if (!$('gifts')) return; // box removed from the section; kept for older markup
    const cell = (ok, art, name, okLine, lockLine) =>
      `<div class="gcell ${ok ? 'on' : 'off'}"><div class="gart">${art}${ok ? '' : lock}</div><div class="gname">${name}</div>${ok ? okLine : `<div class="glockline">${lockLine}</div>`}</div>`;
    const giftN = minPieces('freeGift');
    const shipLock = current === SINGLE ? (moreStones() === 1 ? `Add a ${ord(count() + 1)} stone to unlock` : `Add ${moreStones()} more stones to unlock`) : `Free with ${FREE_STONES}+ stones`;
    $('gifts').innerHTML =
      cell(freeFor(current), truck, 'Free UK delivery', `<div class="gfree">${SHIP ? `<s>${money(SHIP)}</s> ` : ''}FREE</div>`, shipLock) +
      (!giftN ? '' : '<span class="gplus">+</span>' +
      cell(current.freeGift, `<img src="${D.giftImg}" alt="Bonus sensory mat tile">`, 'Sensory mat tile', (D.giftPrice ? `<div class="gfree"><s>${D.giftPrice}</s> FREE</div>` : '<div class="gfree">INCLUDED</div>'), giftN ? `Unlock with ${giftN} pieces` : ''));
  }

  function update() {
    renderBundles(); renderGifts(); renderPicker(); renderLadder(); syncCoupon();
    const isSingle = current === SINGLE;
    const q = qty(), save = isSingle ? (SINGLE.price - singleUnit(q)) * q : (current.was - current.price) * q;
    const wasTotal = isSingle ? SINGLE.price * q : current.was * q;
    // 27 Oct (Glow Wand): a ticked add-on tile (assets/glow-addon.js) adds its price to the button and sticky bar.
    // The strike-through still only shows this product's own saving. No tile or not ticked: ax = 0, nothing changes.
    const ax = window.GlowAddon ? window.GlowAddon.extra() : 0;
    if ($('bundleName')) $('bundleName').textContent = isSingle ? (q === 1 ? '1 stone' : q + ' stones') : current.pieces + ' pieces';
    $('ctaPrice').innerHTML = (save > 0 ? `<s>${money(wasTotal + ax)}</s> ` : '') + money(total() + ax);
    $('stickyName').textContent = isSingle
      ? (q === 1 ? singleLabel(tray[0].sh, tray[0].c) : q ? `${q} stones: ${trayText()}` : 'Pick your stones')
      : (current.title || ('Buy ' + current.pieces));
    if (ax) $('stickyName').textContent += ' + ' + window.GlowAddon.name;
    if (current.img) $('stickyImg').src = current.img;
    $('stickyWas').textContent = save > 0 ? money(wasTotal + ax) : '';
    $('stickySave').textContent = save > 0 ? 'Save ' + money(save) : '';
    $('stickyPrice').textContent = money(total() + ax);
    if (stickyNudge) {
      const show = isSingle && q > 0 && !!nextStep(q) && q + moreStones() <= MAX_Q;
      stickyNudge.hidden = !show;
      stickyNudge.innerHTML = show ? `<span class="sp-plus" aria-hidden="true">+</span><span>${nudgeText()}</span>` : '';
      $('sticky').classList.toggle('has-nudge', show);
    }
    if ($('mixNote')) $('mixNote').hidden = isSingle;
    if ($('boxContents')) $('boxContents').innerHTML = isSingle
      ? (q ? `<b>Single stone${q > 1 ? 's' : ''}:</b> ${trayText(tray.length)} (light-up).` : '<b>Single stones:</b> tap a colour to add a stone.')
      : `<b>In the ${current.pieces}-piece set:</b> ${current.box}` + (current.freeGift ? ' <b>Plus a bonus sensory mat tile</b> (1 liquid gel tile), only with this set.' : '');
    const canBuy = current.available && (!isSingle || q > 0);
    $('addToCart').disabled = !canBuy;
    const stCta = document.querySelector('#sticky .st-cta'); if (stCta) stCta.disabled = !canBuy;
  }

  /* ---------- delivery date ---------- */
  (function () {
    const d = new Date(); let n = 0;
    while (n < D.deliveryDays) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; }
    if ($('deliveryDate')) $('deliveryDate').textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  })();

  /* ---------- add to cart: set variant + gift (made free by an automatic discount) ---------- */
  /* Singles go in as one line per shape + colour (same variant, Shape + Colour line item properties for fulfilment),
     all in one /cart/add.js call. They never carry _glow_unlock, so they never get the gift. */
  $('addToCart').onclick = async () => {
    const isSingle = current === SINGLE;
    if (isSingle && !count()) return;
    const btn = $('addToCart'); btn.disabled = true; $('glowError').hidden = true;
    const gift = current.freeGift && !isSingle;
    const items = isSingle
      ? tray.filter(r => r.n > 0).map(r => ({ id: S.variantId, quantity: r.n, properties: { Shape: S.shapes[r.sh].name, Colour: S.colours[r.c].name } }))
      : [{ id: current.variantId, quantity: 1, properties: Object.assign(gift ? { _glow_unlock: '1' } : {}, D.preorderProp ? { 'Pre-order': D.preorderProp } : {}) }];
    if (gift && D.giftVariantId) items.push({ id: D.giftVariantId, quantity: 1, properties: { _glow_gift: '1' } });
    // 27 Oct (Glow Wand): the ticked add-on goes in right after the main item (never on its own); if it fails
    // (e.g. just sold out) the main item is still in the cart and the drawer shows what's there.
    const addonItems = window.GlowAddon ? window.GlowAddon.items() : [];
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error(await r.text());
      if (addonItems.length) {
        try {
          const ra = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: addonItems }),
          });
          if (ra.ok && window.GlowAddon.added) window.GlowAddon.added();
        } catch (e) { console.error(e); }
      }
      // the cart drawer's render adds / removes the free gifts for the stone count (Glow Sensory Spinner at 4+, mat tile at 6+)
      if (D.afterAdd === 'checkout') { if (window.GlowCart) { try { await window.GlowCart.refresh(); } catch (e) {} } window.location.href = '/checkout'; return; }
      if (window.GlowCart) { window.GlowCart.open(); btn.disabled = false; } else { window.location.href = '/cart'; }
    } catch (e) {
      console.error(e); $('glowError').hidden = false; btn.disabled = false;
    }
  };

  /* ---------- sticky bar once the main CTA scrolls away ---------- */
  const sticky = $('sticky');
  // mobile: the bar shows as soon as they scroll past the gallery, and hides only while the main button is on screen
  const mainCta = $('addToCart');
  const setSticky = () => {
    const r = mainCta.getBoundingClientRect(), onScreen = r.top < innerHeight && r.bottom > 0;
    sticky.classList.toggle('show', !onScreen && (r.bottom <= 0 || window.scrollY > 320));
  };
  new IntersectionObserver(setSticky).observe(mainCta);
  window.addEventListener('scroll', setSticky, { passive: true });

  update();
  document.addEventListener('glow:addon', () => update());
  if (current === SINGLE) showSingleImage();
})();
